/** @format */

import { useEffect } from "react";

const APP_NAME = "Question Bank";

/**
 * Sets `document.title` to a descriptive, page-specific value so pages can be
 * accurately identified in Google Analytics. The provided title is suffixed
 * with the application name, e.g. `Search | Question Bank`.
 *
 * The title is applied in an effect. Because child effects flush before parent
 * effects, this runs before the parent `usePageTracking` effect fires, so the
 * GA4 `page_view` picks up the correct `document.title` on navigation.
 */
export const useDocumentTitle = (title: string): void => {
	useEffect(() => {
		document.title = title ? `${title} | ${APP_NAME}` : APP_NAME;
	}, [title]);
};
